import React from "react"
import Icon from "@ant-design/icons"

const ChevronRightSVG = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49988 4.5L6.44238 5.5575L9.87738 9L6.44238 12.4425L7.49988 13.5L11.9999 9L7.49988 4.5Z"
      fill="#666666"
    />
  </svg>
)

const ChevronRight = props => <Icon component={ChevronRightSVG} {...props} />

export default ChevronRight
